import apiClient from '../apiClient';
import { GET_COUNTRY_BY_ID_URL } from '../apiUrl';

const getCountryByIdApi = Id => {
  return apiClient.get(GET_COUNTRY_BY_ID_URL(Id));
};

export default getCountryByIdApi;
